module.exports = __webpack_public_path__ + "img/banner2.31a611bf.jpg";